import { render, staticRenderFns } from "./cost-centers.vue?vue&type=template&id=3d854877&"
import script from "./cost-centers.vue?vue&type=script&lang=js&"
export * from "./cost-centers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cost-centers.vue"
export default component.exports